var _style, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcerolaCherries({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D5E2DA;}\n\t.st1{fill:none;}\n\t.st2{fill:#70921A;}\n\t.st3{fill:#BE1823;}\n\t.st4{fill:#E05062;}\n\t.st5{fill:none;stroke:#891415;stroke-width:5.2379;stroke-linecap:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.75,119.26c0,0-0.19,0.13-0.45,0.29"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.72,83.82c24.5,10.41,30.69-23.59,30.69-23.59C95.75,59.75,96.72,83.82,96.72,83.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M130.63,57.57c-0.78-0.95-1.94-1.5-3.16-1.53c-12.04-0.18-21.26,2.93-27.42,9.24 c-7.84,8.04-7.52,18.26-7.51,18.69c0.07,1.61,1.05,3.05,2.54,3.68c0.58,0.25,1.15,0.47,1.71,0.67 c6.93,2.51,13.27,2.16,18.85-1.05c12.23-7.03,15.73-25.53,15.87-26.31C131.73,59.77,131.41,58.52,130.63,57.57z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M135.53,117.71c5.32,15.03-2.55,31.54-17.58,36.86c-15.03,5.32-31.54-2.55-36.86-17.58 c-1.51-4.26-2.66-8.85-2.15-13.4c0.49-4.29,2.58-7.91,5.41-11.08c1.95-2.19,4.62-3.61,7.51-4.08c3.2-0.51,6.51,0.46,9.66-0.46 c2.36-0.69,3.53-3.21,5.42-4.6c3.71-2.72,9.43-3.1,13.74-2.01C128.37,103.31,133.03,110.66,135.53,117.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M116.45,109.82c-1.39-0.4-2.83,0.41-3.23,1.79c-0.4,1.39,0.41,2.83,1.79,3.23c2.5,0.71,4.16,2.33,4.92,4.81 c0.39,1.26,1.65,2.01,2.92,1.8c0.12-0.02,0.23-0.05,0.35-0.08c1.38-0.43,2.15-1.89,1.72-3.27 C123.19,112.51,118.87,110.52,116.45,109.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M102.63,108.98c-2.88-4.92-7.29-13.92-8.52-26.02c-1.46-14.32,2.27-25.55,4.51-31.02"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcerolaCherries);
export default __webpack_public_path__ + "static/media/Acerola_cherries.8dc9522264bc10985524bb311ecd5469.svg";
export { ForwardRef as ReactComponent };